module.exports = __webpack_public_path__ + "media/img/home/img_meeting-9d8f33db2620a7a0b17cab2156ae6468.png";